import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ImageComponent } from '../Image';
import { Language } from '@/hooks/languages';

import { ScSwitchLanguageSelect } from './styled';

interface SwitchLanguageSelectProps {
  disabled: boolean;
  onChange: (value: string) => void;
  availableLanguages: Language[];
  variant?: 'full' | 'compact';
}

export const SwitchLanguageSelect = forwardRef<
  HTMLDivElement,
  SwitchLanguageSelectProps
>(({ disabled, onChange, availableLanguages, variant }, ref) => {
  const {
    i18n: { language: currentLang },
  } = useTranslation();
  const { images } = useTheme();

  return (
    <ScSwitchLanguageSelect ref={ref} variant={variant}>
      {availableLanguages.map(({ icon, name, value }) => (
        <button
          key={value}
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            onChange(value);
          }}
          className={currentLang === value ? 'active' : ''}
        >
          <div className="btn-content">
            <ImageComponent
              src={icon}
              width={24}
              height={24}
              alt={currentLang}
            />
            {name}
          </div>

          {currentLang === value && <images.tickCircleIcon.component />}
        </button>
      ))}
    </ScSwitchLanguageSelect>
  );
});
